import React from 'react';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import { ExamsDefault } from './Default/exams';
import { QuestionsPlayfulTeacher } from './PlayfulTeacher/Questions';
import { ExamsPlayfulTeacher } from './PlayfulTeacher';

export function Exams(props) {
  const isPlayfulTeacher = usePlayfulTeacher();

  if (isPlayfulTeacher && props.selectedTab === 'banco-de-questoes') {
    return <QuestionsPlayfulTeacher {...props} />;
  }

  if (isPlayfulTeacher && props.selectedTab === 'provas') {
    return <ExamsPlayfulTeacher {...props} />;
  }

  return <ExamsDefault {...props} />;
}
